import { AdjustedTime } from "model/Match/AdjustedTime";
import { PointsDistribution } from "model/Match/Set/PointsDistribution";
import { TimeAttackScoring, TimeAttackScoringBase } from "./TimeAttackScoring";

export type TimeAttackScoringPoints = TimeAttackScoringBase & {
  points: PointsDistribution;
  type: "Points";
};

export const isTimeAttackScoringPoints = (
  scoring: TimeAttackScoring
): scoring is TimeAttackScoringPoints => {
  return (scoring as TimeAttackScoringPoints).type === "Points";
};

export const getTimeAttackPointsScore = (
  times: (AdjustedTime | undefined)[]
): number => {
  return times.reduce((a, b) => a + (b?.time ?? 0), 0);
};
